import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import { faSearch, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalf } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";

//import "rsuite/dist/rsuite.css";

import {
  utilGetDocumentFilters,
  utilGetDocumentById,
} from "../../../util/UtilsFirebase";

// style
import "./Calificaciones.css";
import { Table, Form, Pagination } from "react-bootstrap";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import moment from "moment";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { DateTime } from "luxon";

export default function Calificaciones() {
  const { user, register } = useAuthContext();
  const [data, setData] = useState([]);
  const [dataMes, setDataMes] = useState([]);
  const [userData, setUserData] = useState({});
  const [userDetails, setUserDetails] = useState({});
  /* Filtros Tablas */
  const [dateRange, setDateRange] = useState([]);
  const handleDateRangeChange = (dateRangeP) => {
    let filtros = [];
    console.log(dateRangeP);
    if (dateRangeP) {
      filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "fecha", operador: ">=", valor: dateRangeP[0] },
        { campo: "fecha", operador: "<=", valor: dateRangeP[1] },
      ];
    } else {
      const localTimeZone = "America/Hermosillo"; // Zona horaria de Nogales, Sonora
      const currentDate = DateTime.now().setZone(localTimeZone);
      const startOfDay = currentDate.startOf("day");
      filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        //{ campo: 'fecha', operador: '>=', valor: startOfDay.toJSDate() }
      ];
    }

    const fetchOrders = utilGetDocumentFilters("resena_general", filtros);
    fetchOrders
      .then((fetchedOrders) => {
        //console.log(fetchedOrders);
        setData(fetchedOrders);
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
    setDateRange({ dateRange });
  };

  const [dateRangeMes, setDateRangeMes] = useState([]);
  const handleDateRangeChangeMes = (dateRangeMes) => {
    setDateRangeMes({ dateRangeMes });
  };

  const [filterText, setFilterText] = useState("");
  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  const filteredData = data.filter((item) => {
    const date = new Date(item.fecha.toDate());
    //console.log(dateRange)
    if (dateRange.dateRange) {
      //console.log(dateRange.dateRange[0]);
      //console.log(dateRange.dateRange[1]);
      return (
        item.user.toString().toLowerCase().includes(filterText.toLowerCase()) ||
        item.resena
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        (item.resena_calificacion
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) &&
          date >= dateRange.dateRange[0] &&
          date <= dateRange.dateRange[1])
      );
    } else {
      return (
        item.user.toString().toLowerCase().includes(filterText.toLowerCase()) ||
        item.resena
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.resena_calificacion
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase())
      );
    }
  });

  const [filterTextMes, setFilterTextMes] = useState("");
  const handleFilterTextChangeMes = (event) => {
    setFilterTextMes(event.target.value);
  };

  const filteredDataMes = dataMes.filter((item) => {
    const date = new Date(item.fecha.toDate());
    console.log(dateRangeMes);
    if (dateRangeMes.dateRangeMes) {
      console.log(dateRangeMes.dateRangeMes[0]);
      console.log(dateRangeMes.dateRangeMes[1]);

      return (
        (moment(item.fecha.toDate())
          .format("DD/MM/YYYY")
          .toLowerCase()
          .includes(filterTextMes.toLowerCase()) ||
          item.user.toLowerCase().includes(filterTextMes.toLowerCase())) &&
        date >= dateRangeMes.dateRangeMes[0] &&
        date <= dateRangeMes.dateRangeMes[1]
      );
    } else {
      return (
        moment(item.fecha.toDate())
          .format("DD/MM/YYYY")
          .toLowerCase()
          .includes(filterTextMes.toLowerCase()) ||
        item.user.toLowerCase().includes(filterTextMes.toLowerCase())
      );
    }
  });

  /* Ordenar tablas */
  const [sortType, setSortType] = useState("asc");
  const sortedData = filteredData ? filteredData.sort(sortData(sortType)) : [];
  function sortData(sortType) {
    return function (a, b) {
      if (sortType === "asc") {
        return moment(a.fecha.toDate())
          .format("DD/MM/YYYY")
          .localeCompare(moment(b.fecha.toDate()).format("DD/MM/YYYY"));
      } else {
        return moment(b.fecha.toDate())
          .format("DD/MM/YYYY")
          .localeCompare(moment(a.fecha.toDate()).format("DD/MM/YYYY"));
      }
    };
  }

  /* Paginado Tablas */
  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 10;

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  /* Funcion de estrellas */
  function renderStars(calificacion) {
    const stars = [];
    const roundedRating = Math.round(calificacion);
    for (let i = 1; i <= 5; i++) {
      if (i <= roundedRating) {
        stars.push(<FontAwesomeIcon key={i} icon={faStar} />);
      } else if (i - 0.5 === roundedRating) {
        stars.push(<FontAwesomeIcon key={i} icon={faStarHalf} />);
      } else {
        stars.push(<FontAwesomeIcon key={i} icon={faStarRegular} />);
      }
    }
    return stars;
  }

  useEffect(() => {
    const filtros = [{ campo: "puesto", operador: "==", valor: register.id }];

    const fetchOrders = utilGetDocumentFilters("resena_general", filtros);
    fetchOrders
      .then((fetchedOrders) => {
        setData(fetchedOrders);

        // Fetch user details for each review
        const userPromises = fetchedOrders.map((val) =>
          utilGetDocumentById("users", val.user)
            .then((user) => ({ [val.user]: user })) // Create an object with userId as key and user details as value
            .catch((error) => {
              console.error("Error fetching user data:", error);
              return { [val.user]: null }; // Return null if there's an error fetching user details
            })
        );

        // Wait for all user data promises to resolve
        Promise.all(userPromises).then((userDetailsArray) => {
          // Combine user details into a single object
          const combinedUserDetails = Object.assign({}, ...userDetailsArray);
          setUserDetails(combinedUserDetails);
        });
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, [register.id]);
  return (
    <div>
      <br />
      <h4 className="page-title">
        {register.type === "truck-admin"
          ? "COMENTARIOS DE LA PLAZA"
          : "COMENTARIOS DEL NEGOCIO"}
      </h4>
      <br />
      <br />
      <br />
      <div className="container">
        <>
          <div className="mrg-titulo mrg-tbl"></div>
          <div className="row">
            <div className="col-sm-3">
              <div className="input-group">
                <Form.Control
                  className="form-control border-end-0 border rounded-pill"
                  type="text"
                  aria-describedby="search-icon"
                  placeholder="Busqueda"
                  value={filterText}
                  onChange={handleFilterTextChange}
                />
                <span className="input-group-append">
                  <button
                    className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                </span>
              </div>
            </div>
            <div className="col-lg-12 mrg-tbl">
              <Table striped bordered hover border="2">
                <thead>
                  <tr>
                    <th
                      onClick={() =>
                        setSortType(sortType === "asc" ? "desc" : "asc")
                      }
                    >
                      {" "}
                      <FontAwesomeIcon icon={faSort} /> Fecha
                    </th>
                    <th>Cliente</th>
                    <th>Comentarios</th>
                    <th>Calificación</th>
                  </tr>
                </thead>
                <tbody>
                  {getElementsForPage(currentPage)
                    .sort()
                    .map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {moment(val.fecha.toDate()).format("DD/MM/YYYY")}
                          </td>
                          <td>
                            {userDetails[val.user]
                              ? userDetails[val.user].fullName
                              : "Usuario Desconocido"}
                          </td>
                          <td>{val.resena ? val.resena : "No dejo reseña"}</td>
                          <td>
                            {val.resena_calificacion}{" "}
                            {val.resena_calificacion
                              ? renderStars(val.resena_calificacion)
                              : ""}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({
                  length: Math.ceil(filteredData.length / elementsPerPage),
                }).map((page, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    className={index + 1 === currentPage ? "btn-paginado" : ""}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}
